import { useState } from 'react';
import Cookie from 'js-cookie';

const cookieConsentKey = 'cookie-consent-given';

/**
 * React hook that checks the presence of the consent cookie on the start up.
 * @returns {{isCookieAllowed: boolean, onCookieConsentGiven: function}} - returns `isCookieAllowed` to indicate cookie
 * presence and `onCookieConsentGiven` to save the cookie.
 */
const useCookieConsent = () => {
  const [isCookieAllowed, setCookieAllowed] = useState(Cookie.get(cookieConsentKey));

  const onCookieConsentGiven = () => {
    Cookie.set(cookieConsentKey, true, { expires: 365, domain: 'clearvpn.com' }); // set consent for a year
    setCookieAllowed(true);
  };

  return {
    isCookieAllowed,
    onCookieConsentGiven
  };
};

export {
  useCookieConsent
};
